import { Paper, RaisedButton, TextField } from 'material-ui';
import React, { useState } from 'react';
import '../LoginAsPage.scss';
import api from 'services';

const namesMapper = {
    mail: 'Mail',
    mailArchive: 'Mail archived',
    cargo: 'Cargo',
    cargoRequest: 'Cargo request',
    position: 'Position',
    tc: 'Tc',
    sales: 'Sales',
    user: 'User',
    company: 'Company',
    vessel: 'Vessel',
    calculation: 'Calculation',
    contract: 'Contract',
    contractTc: 'Contract Tc',
    contractVoy: 'Contract Voyage',
    mailGate: 'Mail Gate',
    port: 'Port',
    region: 'Region',
};

export default function IdsEntities() {
    const [toIdentify, setToIdentify] = useState('');
    const [result, setResult] = useState('');
    
    const identify = async () => {
        if (!toIdentify) return;

        const res = await api.idsEntities(toIdentify);

        let resString = '';

        if (res.data && Object.keys(res.data).length) {
            Object.entries(res.data).filter(([_key, value]) => value).forEach(([key, _value]) => {
                resString += `${resString ? ', ' : ''}${namesMapper[key]}`;
            });
        }

        setResult(resString);
    };

    return (
        <Paper style={{ padding: '20px' }} zDepth={2} rounded={false} className="wrapper">
            <div>
                <h4>That block allows to identify system entity by id.</h4>

                <div className='idsEntities-ops'>
                    <TextField 
                        value={toIdentify}
                        hintText='Entity ObjectId'
                        onChange={e => setToIdentify(e.target.value)}
                        style={{ fontSize: '13px' }}
                        onKeyDown={e => e.keyCode === 13 && identify}
                    />
                    <RaisedButton label="Submit" primary onClick={identify} />
                    {
                        result ?
                            <React.Fragment>
                                <code style={{ color: 'gray' }}> {'-->'} </code>
                                <span>{result}</span>
                            </React.Fragment> : null
                    }
                </div>
                <div style={{ color: 'gray', fontSize: '13px', marginTop: '15px' }}>Possible values: Mail, Mail archived, Cargo, Cargo request, Position, Tc, Sales, Port, Region, User, Company, Vessel, Calculation, Contract, Contract Tc, Contract Voyage, Mail Gate.</div>
            </div>
        </Paper>
    );
}



// WEBPACK FOOTER //
// ./app/components/LoginAsPage/IdsManipulators/IdsEntities.jsx